<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item>
              <el-input placeholder="编号 / 名称 / 条形码 / 拼音码" v-model="query.key" clearable @keyup.enter.native="getlists" @change="isnewselect=true"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getlists">搜索</el-button>
          </el-form-item>
      </el-form>

      <div style="margin-top:10px;font-size:.7rem;border-radius:5px;padding:.3rem 1% .3rem 1%;background:rgb(211,211,211,.6)">
			    <span style="color:red">温馨提示：默认全部商品都可以发布到合作代理商的线上商城平台销售</span>
		  </div>

      <div class="backborder2" style="margin-top:10px">
	        <el-table :data="lists" v-loading="listsloading">
	            <el-table-column prop="agentname" label="合作商名称"></el-table-column>
	            <el-table-column prop="allnums" label="系统商品数量" width="170" align="center"></el-table-column>
              <el-table-column prop="liminums" label="限制销售商品数量" width="170" align="center"></el-table-column>
              <el-table-column prop="lastnums" label="可销售商品数量" width="170" align="center"></el-table-column>
	            <el-table-column label="操作" width="100" align="center">
		            <template slot-scope="scope">
		                <el-button type="warning" size="small" circle icon="el-icon-setting" @click="setpushgoods(scope.row)"></el-button>
		            </template>
	            </el-table-column>
	        </el-table>
          <div class="block">
	        <!--分页begin-->
	        <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_rows">
	        </el-pagination>
	        <!--分页end-->
	        </div>  
      </div>

      <!-- 获取限制销售的商品信息 -->
      <el-dialog title="限制销售商品信息" :visible.sync="pushDialog" width="70%" top="5vh">

          <el-form :inline="true" class="demo-form-inline" size="mini">
              <el-form-item size="small" style="width:15%">
                  <el-select v-model="limitquery.brandid" clearable filterable placeholder="按品牌" @change="pushischange=true" :filter-method="changeselectbrand">
                      <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                          <span style="float: left">{{item.name}}</span>
                          <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item ref="query" :model="query">
                  <el-input placeholder="编号 / 名称 / 条形码 / 拼音码" v-model="limitquery.key" clearable @keyup.enter.native="getlimitgoods" @change="pushischange=true"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="getlimitgoods">查询</el-button>
              </el-form-item>
              <el-form-item v-if="selectdel===true">
                  <template slot-scope="scope">
                      <span style="font-size:.7rem">已选择 <i style="font-style:normal;font-weight:bold;font-size:.9rem;color:red">{{selectdellists.length}}</i> 个商品</span>
                  </template>
              </el-form-item>
              <el-form-item v-if="selectdel==true">
                  <el-button size="mini"  @click="selectdelcannel" style="float:left">取消选择</el-button>
              </el-form-item>
              <el-form-item>
                  <el-button size="mini" :type="selectdel==false ? 'primary' : 'danger'" @click="selectdelandsure" style="float:left">{{selectdel==false ? '选择商品' : '确认删除' }}</el-button>
              </el-form-item>
              <el-form-item>
                  <el-button size="mini" type="danger" v-if="selectdel==false"  @click="addgoods" style="float:left">新增商品</el-button>
              </el-form-item>
          </el-form>

          <el-table ref="limitmultipleTable" :data="limilists" v-loading="pushloading" @row-click="limitrowclick" @select="limithandleSelectsingle"  @select-all="limithandleSelectall">
              <el-table-column type="selection" width="40" v-if="selectdel==true"></el-table-column>
	            <el-table-column label="商品信息">
                  <template slot-scope="scope">
                      <span style="float:left;width:100%">{{scope.row.name}}</span>
                      <span style="float:left;font-size:.7rem;color:#909399">规格：{{scope.row.spec}}</span>
                      <span style="float:left;margin-left:2%;font-size:.7rem;color:#909399">商品编号：{{scope.row.number}}</span>
                      <span style="float:left;width:100%;font-size:.7rem;color:#909399">商品条码：{{scope.row.basebarcode}}</span>
                  </template>
              </el-table-column>
              <el-table-column label="品牌" prop="brandname" width="170"></el-table-column>
              <el-table-column label="进货价" prop="buy" width="120" align="center"></el-table-column>
              <el-table-column label="批发价" prop="sell" width="120" align="center"></el-table-column>
              <el-table-column label="零售价" prop="market" width="120" align="center"></el-table-column>
	        </el-table>
          <div class="block">
	        <!--分页begin-->
	        <el-pagination
	            @size-change="limitpageSizeChange"
	            @current-change="limitpageCurrentChange"
	            :current-page="limitquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="limitquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="limi_rows">
	        </el-pagination>
	        <!--分页end-->
	        </div>  
      </el-dialog>


      <!-- 获取新增销售商品信息 -->
      <el-dialog title="添加限制商品信息" :visible.sync="addgoodsDialog" width="70%" top="5vh">

          <el-form :inline="true" class="demo-form-inline" size="mini">
              <el-form-item size="small" style="width:15%">
                  <el-select v-model="productsquery.brandid" clearable filterable placeholder="按品牌" @change="isproductselect=true" :filter-method="changeselectbrand">
                      <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                          <span style="float: left">{{item.name}}</span>
                          <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item ref="query" :model="query">
                  <el-input placeholder="编号 / 名称 / 条形码 / 拼音码" v-model="productsquery.key" clearable @keyup.enter.native="getproductList" @change="isproductselect=true"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="getproductList">查询</el-button>
              </el-form-item>
          </el-form>

          <el-table ref="multipleTable" :data="productlists" v-loading="productLoading" @row-click="rowclick" @select="handleSelectsingle"  @select-all="handleSelectall">
              <el-table-column type="selection" width="40"></el-table-column>
	            <el-table-column label="商品信息">
                  <template slot-scope="scope">
                      <span style="float:left;width:100%">{{scope.row.name}}</span>
                      <span style="float:left;font-size:.7rem;color:#909399">规格：{{scope.row.spec}}</span>
                      <span style="float:left;margin-left:2%;font-size:.7rem;color:#909399">商品编号：{{scope.row.number}}</span>
                      <span style="float:left;width:100%;font-size:.7rem;color:#909399">商品条码：{{scope.row.basebarcode}}</span>
                  </template>
              </el-table-column>
              <el-table-column label="品牌" prop="brandname" width="170"></el-table-column>
              <el-table-column label="进货价" prop="buy" width="120" align="center"></el-table-column>
              <el-table-column label="批发价" prop="sell" width="120" align="center"></el-table-column>
              <el-table-column label="零售价" prop="market" width="120" align="center"></el-table-column>
	        </el-table>
          <div class="block">
	        <!--分页begin-->
	        <el-pagination
	            @size-change="productpageSizeChange"
	            @current-change="productpageCurrentChange"
	            :current-page="productsquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="productsquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="product_rows">
	        </el-pagination>
	        <!--分页end-->
	        </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="addgoodsDialog = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="addlimitproduct">保 存</el-button>
            </div>  
      </el-dialog>


  </div>
  </transition> 
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Product/index",
      transitionshow:true,
      lists:[],
      listsloading:false,
      isnewselect:false,
      total_rows:0,
      query: {
          act:'getsplitagent',
      	  token:this.$cookies.get('token'),
          key:'',
          p:1,
          rollpage:10
      },
      limitquery: {
          act:'lmgoods',
          token:this.$cookies.get('token'),
          id:'',
          agentid:'',
          inventorytype:'',
          brandid:'',
          catids:[],
          key:'',
          p:1,
          rollpage:10
      },
      pushDialog:false,
      pushloading:false,
      pushischange:false,
      limilists:[],
      limi_rows:0,
      selectdel:false,
      selectdellists:[],
      brandquery:{
          act:'lists',
          token:this.$cookies.get('token'),
          key:'',
          rollpage: 100000000, // 页大小
          p: 1
      },
      brandlists:[],
      addgoodsDialog:false,
      isproductselect:false,
      productLoading:false,
      productlists:[],
      product_rows:0,
      selectaddlists:[],
      productsquery:{
        act:'getaddlimitgoodslists',
        token:this.$cookies.get('token'),
        id:'',
        brandid:'',
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      
      
    }
  },
  mounted(){
      this.getlists();
      this.getbrandlists();
  },
  methods:{

      /** 选择、确认选择商品信息 **/
      selectdelandsure() {
          if(this.selectdel==true) { //确认取消删除限制销售商品信息
              if(this.selectdellists.length==0) {this.$message.error("请选择需要取消的商品信息");return false;}
              var resource = this.$resource(this.url);
              resource.query({act:'delagentpid',token:this.$cookies.get('token'),id:this.limitquery.id,pids:this.selectdellists}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                  }else{
                      this.$message.success("取消限制销售商品信息成功");
                      this.selectdel=false;
                      this.pushDialog=false;
                      this.getlists();
                  }
              }).catch((res) => {
                
              });
          
          }else {
              this.selectdel=true;
          }
      },

      /** 取消选择商品信息 **/
      selectdelcannel() {
          this.selectdel=false;
          var _this=this;
          var number=0;
          this.limilists.forEach(function(item,i) {
              number=_this.selectdellists.indexOf(item.id);
              number >= 0 ? _this.$refs.limitmultipleTable.toggleRowSelection(item) : '';
          });
          this.selectdellists=[];
      },

      /** 单行点击选择待删除商品 **/
      limitrowclick(val,row) {
          if(this.selectdel==false) return false;
          var number=this.selectdellists.indexOf(val.id);
          number >= 0 ? this.selectdellists.splice(number,1) : this.selectdellists.push(val.id);
          this.$refs.limitmultipleTable.toggleRowSelection(val);
      },

      /** 手动点击选择单个 **/
      limithandleSelectsingle(val,row) {
          if(this.selectdel==false) return false;
          var number=this.selectdellists.indexOf(row.id);
          number >= 0 ? this.selectdellists.splice(number,1) : this.selectdellists.push(row.id);
      },

      /** 点击全选 **/
      limithandleSelectall(val) {
          if(this.selectdel==false) return false;
          var _this=this;
          var number=0;
          if(val.length > 0) { //全选
              val.forEach(function(item,i) {
                  number=_this.selectdellists.indexOf(item.id);
                  number >=0 ? '' : _this.selectdellists.push(item.id);
              });
          }else { //全不选
              var ids=[];
              this.limilists.forEach(function(item,i) {ids.push(item.id)});
              ids.forEach(function(item,i) {
                  number=_this.selectdellists.indexOf(item);
                  number >=0 ? _this.selectdellists.splice(number,1) : '';
              });
          }
      },


      /** 获取合作代理商信息 **/
      getlists() {
          if(this.isnewselect==true) {
              this.query.p=1;
              this.query.rollpage=10;
          }

          this.listsloading=true;
          var resource = this.$resource(this.url);
          resource.query(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.listsloading=false;
              }else{
                  this.lists = JSON.parse(Base64.decode(res.data.Data));
                  this.total_rows=parseInt(res.data.count);
                  this.listsloading=false;
                  if(this.isnewselect==true) this.isnewselect=false;
              }
          }).catch((res) => {
              this.listsloading=false;
          });
      },

      pageSizeChange(val) {
          this.query.rollpage = val;
          this.getlists();
      },
      pageCurrentChange(val) {
          this.query.p = val;
          this.getlists();
      },


      /** 查询合作代理商的商品信息 **/
      setpushgoods(item) {
          this.limitquery.id=item.id;
          this.limitquery.agentid=item.agentid;
          this.limitquery.inventorytype='';
          this.limitquery.brandid='';
          this.limitquery.catids=[];
          this.limitquery.key='';
          this.limitquery.p=1;
          this.limitquery.rollpage=10;
          this.pushDialog=true;
          this.selectdellists=[];
          this.selectdel=false;
          this.getlimitgoods();
      },

      /** 获取限制发布的商品信息 **/
      getlimitgoods() {
          if(this.pushischange==true) {
              this.limitquery.p=1;
              this.limitquery.rollpage=10;
          }

          this.pushloading=true;
          var resource = this.$resource(this.url);
          resource.query(this.limitquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.pushloading=false;
              }else{
                  this.limilists = JSON.parse(Base64.decode(res.data.Data));
                  this.limi_rows=parseInt(res.data.count);
                  this.pushloading=false;
                  if(this.pushischange==true) this.pushischange=false;

                  var _this=this;
                  var number=0;
                  setTimeout(function() {
                      _this.limilists.forEach(function(item,i) {
                          number=_this.selectdellists.indexOf(item.id);
                          number >= 0 ? _this.$refs.limitmultipleTable.toggleRowSelection(item) : '';
                      });
                  },150);

              }
          }).catch((res) => {
              this.pushloading=false;
          });
      },

      limitpageSizeChange(val) {
          this.limitquery.rollpage = val;
          this.getlimitgoods();
      },
      limitpageCurrentChange(val) {
          this.limitquery.p = val;
          this.getlimitgoods();
      },


      //信息列表
      getbrandlists(){
          var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
          resource.query(this.brandquery).then((res) => {
              if(res.data.Result>0){
            	  if(res.data.Result=='70001') this.$router.push('/login')
            	  this.$message.error(res.data.Message);
              }else{
            	  this.brandlists = JSON.parse(Base64.decode(res.data.Data));
              }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
          });
      },


      /** 获取新增商品信息 **/
      addgoods() {
          this.addgoodsDialog=true;
          this.productsquery.brandid='';
          this.productsquery.key='';
          this.productsquery.p=1;
          this.productsquery.id=this.limitquery.id;
          this.productsquery.rollpage=10;
          this.selectaddlists=[];
          this.getproductList();
      },

      /** 保存新增商品信息 **/
      addlimitproduct() {
          if(this.selectaddlists.length == 0) {this.$message.error("请选择要添加的商品信息");return false;}
          this.$confirm('新增商品会导致这些商品从合作的代理商上下架，您是否同意，继续?', '提示', { type: 'warning' }).then(() => {
	          
              var resource = this.$resource(this.url);
              resource.query({act:'savelimitproducts',token:this.$cookies.get('token'),id:this.productsquery.id,pids:this.selectaddlists}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                  }else{
                      this.$message.success("新增限制销售商品信息成功");
                      this.addgoodsDialog=false;
                      this.getlimitgoods();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
              });

	      }).catch(() => {
	            
	      });
      },

      /** 商品信息列表 **/
      getproductList(){
    	  if(this.isproductselect==true) {
			  this.productsquery.p=1;
			  this.productsquery.rollpage=10;	    	
    	  }
    
          this.productLoading = true;
          var resource = this.$resource(this.url);
          resource.query(this.productsquery).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	              this.productLoading = false;
	          }else{
	              this.productlists = JSON.parse(Base64.decode(res.data.Data));
	              this.product_rows=parseInt(res.data.count);
	              this.productLoading = false;

                  var _this=this;
                  var number=0;
                  setTimeout(function() {
                      _this.productlists.forEach(function(item,i) {
                          number=_this.selectaddlists.indexOf(item.id);
                          number >= 0 ? _this.$refs.multipleTable.toggleRowSelection(item) : '';
                      });
                  },150);

	          }
	        
	          if(this.isproductselect==true) this.isproductselect=false;
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
              this.productLoading=false;
              if(this.isproductselect==true) this.isproductselect=false;
          });
      },
      productpageSizeChange(val) {
          this.productsquery.rollpage = val;
          this.getproductList();
      },
      productpageCurrentChange(val) {
          this.productsquery.p = val;
          this.getproductList();
      },

      /** 单行点击选择待删除商品 **/
      rowclick(val,row) {
          var number=this.selectaddlists.indexOf(val.id);
          number >= 0 ? this.selectaddlists.splice(number,1) : this.selectaddlists.push(val.id);
          this.$refs.multipleTable.toggleRowSelection(val);
      },

      /** 手动点击选择单个 **/
      handleSelectsingle(val,row) {
          var number=this.selectaddlists.indexOf(row.id);
          number >= 0 ? this.selectaddlists.splice(number,1) : this.selectaddlists.push(row.id);
      },

      /** 点击全选 **/
      handleSelectall(val) {
          var _this=this;
          var number=0;
          if(val.length > 0) { //全选
              val.forEach(function(item,i) {
                  number=_this.selectaddlists.indexOf(item.id);
                  number >=0 ? '' : _this.selectaddlists.push(item.id);
              });
          }else { //全不选
              var ids=[];
              this.productlists.forEach(function(item,i) {ids.push(item.id)});
              ids.forEach(function(item,i) {
                  number=_this.selectaddlists.indexOf(item);
                  number >=0 ? _this.selectaddlists.splice(number,1) : '';
              });
          }
      },



  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/inventory/Splitagent.vue